import sensors from 'sa-sdk-javascript';
import host from '@/config/host';
import { ClientUtil, GlobalUtil } from '@xl/js-utils';
import { VueConstructor } from 'vue/types/umd';
import ua from '@xl/user-agent';

const { is_xl_driver_app, isInWeixinMini, isIOS, isAndroid } = ua.parse();

const getPlatformType = () => {
  if (is_xl_driver_app && isIOS) {
    return 'iOS';
  }
  if (is_xl_driver_app && isAndroid) {
    return 'Android';
  }
  if (isInWeixinMini) {
    return '小程序';
  }
  return 'H5';
};

// 将设备信息透传至神策
// 安卓新增imei/oaid/android_id/h_device_id
type DeviceInfo = {
  imei: string;
  oaid: string;
  android_id: string;
  h_device_id: string;
};
const setDeviceInfo = () => {
  if (is_xl_driver_app && isAndroid) {
    ClientUtil.webcall(
      {
        action: 'getDeviceParams',
      },
      (res?: string) => {
        if (res) {
          const obj: DeviceInfo = JSON.parse(res || '{}');
          sensors.registerPage(obj);
        }
      },
    );
  }
};

/**
 * 华为新增付费推广的归因信息
 * channel：由广告主运营在华为投放系统针对广告任务绑定的智能分包渠道号，如"channel12345"。
 * callback：回传参数，用于oCPD对接，如"security:CD40F6*****C7A9F4"。
 * taskid：任务ID，如"200052202"。
 * subTaskId：子任务ID，如"200037037"。
 * RTAID：RTAID，如"123556"。
 */
type HUAWEI_TRACK_TYPE = {
  channel: string;
  callBack: string;
  taskId: string;
  subTaskId: string;
  rtaid: string;
};
const setTrackHUAWEI = () => {
  if (is_xl_driver_app && isAndroid) {
    ClientUtil.webcall(
      {
        action: 'huaweiTrackId',
      },
      (res?: string) => {
        if (res) {
          const obj: HUAWEI_TRACK_TYPE = JSON.parse(res || '{}');
          const areAllKeysEmpty = Object.values(obj).every(
            (value) => value === null || value === '' || value === undefined,
          );
          if (!areAllKeysEmpty) {
            sensors.registerPage(obj);
          }
        }
      },
    );
  }
};

sensors.init({
  server_url: host.SA_HOST,
  is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time: true,
  send_type: 'beacon',
  heatmap: {
    // 是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: 'not_collect',
    // 是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'not_collect',
  },
  show_log: true, //! isProduction // 是否控制台打印日志
});

function install(Vue: VueConstructor) {
  Vue.prototype.$sa = sensors;
  Vue.prototype.$track = sensors.track;
  sensors.registerPage({
    url: window.location.href,
    platform_type: getPlatformType(), // 公共平台参数：Android、iOS、H5、小程序
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ...GlobalUtil.globalSensorProp(),
  });
  sensors.quick('autoTrack');

  setDeviceInfo();
  setTrackHUAWEI();
}

export default {
  install,
};

export { sensors };
